/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogSubscriptionItemDTO,
  CatalogSubscriptionItemDTOOptional,
  CatalogSubscriptionItemDTOMetaI,
  CatalogSubscriptionItemDTOTrackedI,
} from "./catalog-subscription-item-dto";
import {
  CatalogSubscriptionItemDTOTracked,
  CatalogSubscriptionItemDTOMeta,
} from "./catalog-subscription-item-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SubscriptionFull,
  SubscriptionFullOptional,
  SubscriptionFullMetaI,
  SubscriptionFullTrackedI,
} from "./subscription-full";
import {
  SubscriptionFullTracked,
  SubscriptionFullMeta,
} from "./subscription-full";

/**
 *
 * @export
 * @interface CatalogSubscriptionDTO
 */
export interface CatalogSubscriptionDTOOptional extends SubscriptionFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogSubscriptionDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogSubscriptionDTO
   */
  billingCycle?: string;
  /**
   *
   * @type {Array<CatalogSubscriptionItemDTO>}
   * @memberof CatalogSubscriptionDTO
   */
  items?: CatalogSubscriptionItemDTOOptional[];
}

export interface CatalogSubscriptionDTO
  extends CatalogSubscriptionDTOOptional, SubscriptionFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogSubscriptionDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CatalogSubscriptionDTO
   */
  billingCycle: string;
  /**
   *
   * @type {Array<CatalogSubscriptionItemDTO>}
   * @memberof CatalogSubscriptionDTO
   */
  items?: CatalogSubscriptionItemDTO[];
}

export interface CatalogSubscriptionDTOTrackedI extends SubscriptionFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogSubscriptionDTO
   */
  name?: string;
  nameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogSubscriptionDTO
   */
  billingCycle?: string;
  billingCycleIsSet: boolean;
  /**
   *
   * @type {Array<CatalogSubscriptionItemDTO>}
   * @memberof CatalogSubscriptionDTO
   */
  items?: CatalogSubscriptionItemDTOTrackedI[];
  itemsIsSet: boolean;
}

transformDatesMap.set(
  "CatalogSubscriptionDTO",
  function (model: CatalogSubscriptionDTO) {
    const transformDatesitems = transformDatesMap.get(
      "CatalogSubscriptionItemDTO",
    );
    if (transformDatesitems) {
      model.items?.forEach((sub) => {
        transformDatesitems(sub);
      });
    }
  },
);

export type CatalogSubscriptionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  name: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  billingCycle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  items: PropertyMeta<CatalogSubscriptionItemDTOMetaI>;
}>;

export var CatalogSubscriptionDTOMeta: CatalogSubscriptionDTOMetaI =
  {} as CatalogSubscriptionDTOMetaI;
CatalogSubscriptionDTOMeta = typeMeta("CatalogSubscriptionDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  name: propertyMeta("name", false, true, false, MetaTypesBase.string),
  billingCycle: propertyMeta(
    "billingCycle",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  items: propertyMeta(
    "items",
    true,
    false,
    false,
    CatalogSubscriptionItemDTOMeta,
  ),
});

const metaI = CatalogSubscriptionDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([SubscriptionFullMeta]);
  metaI.isDeleted.inheritedFrom = SubscriptionFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = SubscriptionFullMeta.isNew;
  metaI.assignId.inheritedFrom = SubscriptionFullMeta.assignId;
  metaI.name.inheritedFrom = SubscriptionFullMeta.name;
  metaI.billingCycle.inheritedFrom = SubscriptionFullMeta.billingCycle;
});

export class CatalogSubscriptionDTOTracked
  extends SubscriptionFullTracked
  implements CatalogSubscriptionDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  name__I?: string = undefined;
  nameIsSet: boolean = false;
  set name(v: undefined | string) {
    if (v !== undefined) {
      this.name__I = v;
      this.nameIsSet = true;
    } else {
      this.name__I = v || undefined;
      this.nameIsSet = true;
    }
    this.changeTracker = true;
  }
  get name() {
    return this.name__I;
  }
  billingCycle__I?: string = undefined;
  billingCycleIsSet: boolean = false;
  set billingCycle(v: undefined | string) {
    if (v !== undefined) {
      this.billingCycle__I = v;
      this.billingCycleIsSet = true;
    } else {
      this.billingCycle__I = v || undefined;
      this.billingCycleIsSet = true;
    }
    this.changeTracker = true;
  }
  get billingCycle() {
    return this.billingCycle__I;
  }
  items__I?: CatalogSubscriptionItemDTOTracked[] = undefined;
  itemsIsSet: boolean = false;
  set items(v: undefined | CatalogSubscriptionItemDTOTracked[]) {
    if (v !== undefined) {
      this.items__I = v;
      this.itemsIsSet = true;
    } else {
      this.items__I = v || undefined;
      this.itemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get items() {
    return this.items__I;
  }
  constructor(
    config?: CatalogSubscriptionDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.items?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: CatalogSubscriptionDTOOptional,
    options?: AssignOptions,
  ): CatalogSubscriptionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.name && this.nameApplyFilter(optionsRequired.filter)) {
      this.name = config.name;
      if (optionsRequired.unassign) this.nameIsSet = false;
      else this.nameIsSet = true;
    }
    if (
      config.billingCycle &&
      this.billingCycleApplyFilter(optionsRequired.filter)
    ) {
      this.billingCycle = config.billingCycle;
      if (optionsRequired.unassign) this.billingCycleIsSet = false;
      else this.billingCycleIsSet = true;
    }
    if (config.items && this.itemsApplyFilter(optionsRequired.filter)) {
      this.items = config.items?.map(
        (a) => new CatalogSubscriptionItemDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemsIsSet = false;
      else this.itemsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogSubscriptionDTOTrackedI {
    const cloned = {} as CatalogSubscriptionDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.nameIsSetDeep() &&
      this.nameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nameIsSet = true;
      cloned.name = this.name;
    } else {
      //cloned.nameIsSet = false
    }
    if (
      this.billingCycleIsSetDeep() &&
      this.billingCycleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingCycleIsSet = true;
      cloned.billingCycle = this.billingCycle;
    } else {
      //cloned.billingCycleIsSet = false
    }
    if (
      this.itemsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemsIsSet = true;
      cloned.items = this.items
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogSubscriptionDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.nameApplyFilter(filter)) this.nameIsSet = false;

    if (!this.billingCycleApplyFilter(filter)) this.billingCycleIsSet = false;

    if (!this.itemsApplyFilter(filter)) this.itemsIsSet = false;

    this.items?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionDTOMeta.isDeleted,
      CatalogSubscriptionDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionDTOMeta.isNew,
      CatalogSubscriptionDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionDTOMeta.assignId,
      CatalogSubscriptionDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  nameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionDTOMeta.name,
      CatalogSubscriptionDTOMeta,
      this.name,
      this,
    );
  }
  nameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nameIsSet && this.nameApplyFilter(filter)) return true;

    return false;
  }
  billingCycleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionDTOMeta.billingCycle,
      CatalogSubscriptionDTOMeta,
      this.billingCycle,
      this,
    );
  }
  billingCycleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingCycleIsSet && this.billingCycleApplyFilter(filter))
      return true;

    return false;
  }
  itemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionDTOMeta.items,
      CatalogSubscriptionDTOMeta,
      this.items,
      this,
    );
  }
  itemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemsIsSet && this.itemsApplyFilter(filter)) return true;

    return this.items?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.nameIsSetDeep(filter)) return true;
    if (this.billingCycleIsSetDeep(filter)) return true;
    if (this.itemsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
